import React from "react";

const DEBIT_CARD = () => {
  return (
    <div className="card_groub">
      <img
        src="https://firebasestorage.googleapis.com/v0/b/food-delivery-37c59.appspot.com/o/Images%2FVisaLogo.png?alt=media&token=d6cac80d-a066-4388-97c2-9a57acfe4266"
        alt=""
        className="card_logo"
      />
      <img
        src="https://firebasestorage.googleapis.com/v0/b/food-delivery-37c59.appspot.com/o/Images%2Fchip.png?alt=media&token=401162f6-2dd2-4da4-bef7-6479c132789c"
        alt=""
        className="card_chip"
      />

      <div className="card_number">
        <div>1234 1223 1223 1233</div>
        <div className="card_form">10/21-24</div>
      </div>
      <div className="card_name">Jaran Doncahaaim</div>
      <div className="card_ring"></div>
    </div>
  );
};

export default DEBIT_CARD;
